// Action Constants

export enum ActionConstant {
	GET_DETAILS = 'FILE://PROFILE_MANAGEMENT/GET_DETAILS',
	GET_STATUS = 'FILE://PROFILE_MANAGEMENT/GET_STATUS',
	CLEAR_DETAILS = 'FILE://PROFILE_MANAGEMENT/CLEAR_DETAILS',
	CLEAR_STATUS = 'FILE://PROFILE_MANAGEMENT/CLEAR_STATUS',
	GET_PROJECT_DETAILS = 'FILE://PROFILE_MANAGEMENT/GET_PROJECT_DETAILS',
	CLEAR_PROJECT_DETAILS = 'FILE://PROFILE_MANAGEMENT/CLEAR_PROJECT_DETAILS',
	GET_SEARCHHISTORY = 'FILE://PROFILE_MANAGEMENT/GET_SEARCHHISTORY',
	CLEAR_SEARCHHISTORY = 'FILE://PROFILE_MANAGEMENT/CLEAR_SEARCHHISTORY',
	CLEAR_AUTOANALYSISLISTDATA = 'FILE://PROFILE_MANAGEMENT/CLEAR_AUTOANALYSISLISTDATA',
	GET_PLAN_LIST = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/GET_PLAN_LIST',
	GET_PLAN_DETAILS = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/GET_PLAN_DETAILS',
	GET_PLAN_STATUS = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/GET_STATUS',
	CLEAR_PLAN_DETAIL = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/CLEAR_DETAILS',
	CLEAR_PLAN_DETAILS = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/CLEAR_PLAN_DETAILS',
	CLEAR_PLAN_STATUS = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/CLEAR_STATUS',
	CLEAR_SUBSCRIPTION_INIT = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/CLEAR_SUBSCRIPTION_INIT',
	GET_PLAN_SUBSCRIBE_START = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/GET_PLAN_SUBSCRIBE_START',
	GET_PLAN_SUBSCRIBE_END = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/GET_PLAN_SUBSCRIBE_END',
	GET_SUBSCRIPTION_SUMMARY = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/GET_SUBSCRIPTION_SUMMARY',
	CLEAR_SUBSCRIPTION_SUMMARY = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/CLEAR_SUBSCRIPTION_SUMMARY',
	GET_PLAN_UNSUBSCRIBE_START = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/GET_PLAN_UNSUBSCRIBE_START',
	GET_PLAN_UNSUBSCRIBE_END = 'FILE://ORGANIZATION_PLAN_MANAGEMENT/GET_PLAN_UNSUBSCRIBE_END',
}

// State Types

export interface Details {
	firstName: string;
	lastName: string;
	phone: string;
	email: string;
	location: string;
	companyName: string;
	id: number;
}

export interface PlanLists {
	type: ActionConstant.GET_PLAN_LIST;
	planCount: number;
	rows: [];
}

export interface Plan {
	id: number;
	name: string;
	description: string;
	documentCount: number;
	documentSize: number;
	scanCount: number;
	projectCount: number;
	tradeCount: number;
	userCount: number;
	duration: number;
	durationUnit: number;
	amount: number;
	order: number;
	packageKey: string;
	priceKey: string;
}

export interface StripeToken {
	card: any;
	clientIp?: string;
	created: number;
	email: string;
	id: string;
	object: string;
	type: string;
	used: boolean;
	livemode: boolean;
	planId?: number;
	autoRenew?: boolean;
}

// Action Types
export interface Lists {
	type: ActionConstant.GET_PROJECT_DETAILS;
	count: number;
	rows: [];
}
export interface SearchLists {
	type: ActionConstant.GET_SEARCHHISTORY;
	searchHistory: [];
}
export interface GetDetailsType {
	type: ActionConstant.GET_DETAILS;
	data: Details;
}
export interface GetListType {
	type: ActionConstant.GET_PROJECT_DETAILS;
	data: Lists;
}
export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}
export interface ClearDetailsType {
	type: ActionConstant.CLEAR_DETAILS;
}
export interface ClearListType {
	type: ActionConstant.CLEAR_PROJECT_DETAILS;
}
export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}
export interface GetSearchHistoryType {
	type: ActionConstant.GET_SEARCHHISTORY;
	data: SearchLists;
}
export interface ClearSearchHistoryType {
	type: ActionConstant.CLEAR_SEARCHHISTORY;
}
export interface ClearAUtoAnalysisList {
	type: ActionConstant.CLEAR_AUTOANALYSISLISTDATA;
}
export interface GetPlanListType {
	type: ActionConstant.GET_PLAN_LIST;
	data: PlanLists;
}
export interface GetPlanType {
	type: ActionConstant.GET_PLAN_DETAILS;
	data: Plan;
}
export interface GetPlanStatusType {
	type: ActionConstant.GET_PLAN_STATUS;
	status: number;
}
export interface ClearPlanListType {
	type: ActionConstant.CLEAR_PLAN_DETAILS;
}
export interface ClearPlanType {
	type: ActionConstant.CLEAR_PLAN_DETAIL;
}
export interface ClearPlanStatusType {
	type: ActionConstant.CLEAR_PLAN_STATUS;
}
export interface GetPlanSubscribeStart {
	type: ActionConstant.GET_PLAN_SUBSCRIBE_START;
}
export interface GetPlanSubscribeEnd {
	type: ActionConstant.GET_PLAN_SUBSCRIBE_END;
}
export interface GetPlanUnsubscribeStart {
	type: ActionConstant.GET_PLAN_UNSUBSCRIBE_START;
}
export interface GetPlanUnsubscribeEnd {
	type: ActionConstant.GET_PLAN_UNSUBSCRIBE_END;
}
export interface GetSubscriptionSummary {
	type: ActionConstant.GET_SUBSCRIPTION_SUMMARY;
	data: any;
}
export interface ClearSubscriptionSummary {
	type: ActionConstant.CLEAR_SUBSCRIPTION_SUMMARY;
}

export type ActionType =
	| GetDetailsType
	| GetListType
	| GetStatusType
	| ClearDetailsType
	| ClearListType
	| ClearStatusType
	| GetSearchHistoryType
	| ClearSearchHistoryType
	| GetPlanListType
	| GetPlanType
	| GetPlanStatusType
	| ClearPlanListType
	| ClearPlanType
	| ClearPlanStatusType
	| GetPlanSubscribeStart
	| GetPlanSubscribeEnd
	| GetSubscriptionSummary
	| ClearSubscriptionSummary
	| GetPlanUnsubscribeStart
	| GetPlanUnsubscribeEnd;

export interface InitialState {
	detailsFetching: boolean;
	details: Details;
	statusCode: number;
	projectdetailsFetching: boolean;
	projectdetails: [];
	count: number;
	searchhistory: [];
	searchcount: number;
	searchhistoryFetching: boolean;
	listFetching: boolean;
	summaryFetching: boolean;
	list: [];
	planStatusCode: number;
	planCount: number;
	planlist: Plan[];
	plan: any;
	ss: any;
}
